import Vue from 'vue';
import '@/assets/css/index.scss'
import 'vant/lib/index.css'
// 按需引用
import {
  Swipe,
  SwipeItem,
  Lazyload,
  Popup,
  Tab,
  Tabs,
  ActionSheet,
  CountDown,
  Overlay,
  Skeleton,
  Toast,
  Sticky,
  Icon,
  Loading
} from 'vant';
import { Image as VanImage } from 'vant';

Vue
.use(Swipe)
.use(SwipeItem)
.use(VanImage)
.use(Lazyload)
.use(Popup)
.use(Tab)
.use(Tabs)
.use(ActionSheet)
.use(Overlay)
.use(Skeleton)
.use(CountDown)
.use(Toast)
.use(Icon)
.use(Loading)
.use(Sticky);

